import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import WithdrawIcon from './icons/WithdrawIcon';
import ConfigsContext from '../../../../contextProviders/ConfigsContext';
import WalletProp, { WALLET_TYPE } from '../../proptype/walletProp';
import WalletCryptoFarmInfo from './WalletCryptoFarmInfo';
import WalletCommissionInfo from './WalletCommissionInfo';
import LoggedUserContext from '../../../../contextProviders/LoggedUserContext';

// import ExchangeIcon from './icons/ExchangeIcon';

function CommissionsWalletActions(props) {
  const { t, onSeeTransactions, onWithdrawal, activeWallet } = props;
  const { type } = activeWallet;
  const { loggedUser } = useContext(LoggedUserContext);
  const { isWithdrawalsEnabled } = loggedUser?.walletSettings || {};
  const { organization } = useContext(ConfigsContext);

  const { f2pool } = organization?.services || {};
  const isF2PoolEnabled = f2pool?.enabled;
  const isCrypto = activeWallet?.type === WALLET_TYPE.CRYPTO;
  const isCoins = activeWallet?.type === WALLET_TYPE.COINS;

  const cryptoBalance = activeWallet?.balance
    ? Number(activeWallet.balance)
    : 0;
  const fiatBalance = activeWallet?.userPriceBalance?.amount || 0;
  const balance =
    activeWallet.type === WALLET_TYPE.FIAT ? fiatBalance : cryptoBalance;
  const isEnabled = balance > 0 && isWithdrawalsEnabled;

  const showFarmInfo = isF2PoolEnabled && isCrypto;

  const sectionTitle = useMemo(() => {
    switch (type) {
      case WALLET_TYPE.COINS:
        return t('commissions.coins.actions');
      default:
        return t('commissions.commissionsActions');
    }
  }, [type]);

  return (
    <div className="commissions-wallet-picker-actions">
      {showFarmInfo && <WalletCryptoFarmInfo wallet={activeWallet} />}
      <div className="commissions-wallet-picker-actions-title">
        {sectionTitle}
      </div>
      <WalletCommissionInfo wallet={activeWallet} />
      {!isCoins ? (
        <>
          <div className="commissions-wallet-picker-actions-buttons">
            <button
              disabled={!isEnabled}
              type="button"
              className="btn m-btn btn-withdraw"
              onClick={onWithdrawal}
            >
              {t('commissions.withdraw')}
              <WithdrawIcon />
            </button>
            {/*
        <button type="button" className="btn m-btn btn-exchange">
          {t('commissions.exchange')}
          <ExchangeIcon />
        </button>
        */}
          </div>
          <button
            type="button"
            className="commissions-wallet-picker-transactions"
            onClick={onSeeTransactions}
          >
            {t('commissions.seeTransactions')}
          </button>
        </>
      ) : null}
    </div>
  );
}

CommissionsWalletActions.propTypes = {
  t: PropTypes.func.isRequired,
  onSeeTransactions: PropTypes.func.isRequired,
  onWithdrawal: PropTypes.func.isRequired,
  activeWallet: PropTypes.shape(WalletProp.propType),
};

CommissionsWalletActions.defaultProps = {
  activeWallet: null,
};

export default translate(CommissionsWalletActions);
